import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private apiUrl = environment.apiURL+'common'; // URL del API

  constructor(private http: HttpClient) {}

  // Método para obtener datos de la API
  getData(): Observable<any> {
    return this.http.get(this.apiUrl+'-data');
  }

  // Método para añadir datos a la API
  getFilterData(item: any): Observable<any> {
    return this.http.get(this.apiUrl+"-filter-data", { params: item });
  }
}
